import { render } from "./ModalLoadingComponent.vue?vue&type=template&id=1977086e"
import script from "./ModalLoadingComponent.vue?vue&type=script&lang=js"
export * from "./ModalLoadingComponent.vue?vue&type=script&lang=js"

import "./ModalLoadingComponent.vue?vue&type=style&index=0&id=1977086e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__